import type { InferGetServerSidePropsType } from 'next';
import { StaticPageRoute } from 'components/route/page/staticPageRoute';
import { staticPageSSRProps } from 'components/route/page/staticPageSSRProps';

export default function StaticPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  return <StaticPageRoute {...props} />;
}

export const getServerSideProps = staticPageSSRProps;
